import Vue from 'vue';
import EmailPreview from '~/bundles/email/components/preview/email_preview';

$(() => {
    const $el = $('#vue-modal');
    window.gl = window.gl || {};

    if (gl.EmailPreviewApp) {
        gl.EmailPreviewApp.$destroy(true);
    }

    if ($el.length) {
        const baseComponent = Vue.component('email-preview', EmailPreview);
        gl.EmailPreviewApp = new baseComponent({
            el: $el.get(0)
        });
    }

    $('#content').on('click', '.email-preview-btn', function() {
        gl.EmailPreviewApp.emailId = $(this).data('emailId');
        gl.EmailPreviewApp.loans = $(this).data('loans');
        gl.EmailPreviewApp.websiteId = $(this).data('websiteId');
        gl.EmailPreviewApp.isOpen = true;
    });

});